import React from 'react';
import { withRouter } from 'react-router-dom';
import { Layout } from '../../../../../components';
import RulesPageFilters from './components/RulesPageFilters/RulesPageFilters';
import RulesPageHeader from './components/RulesPageHeader/RulesPageHeader';
import RulesPageTable from './components/RulesPageTable/RulesPageTable';
import RulesPageTableHeading from './components/RulesPageTableHeading/RulesPageTableHeading';
import styles from './RulesPage.module.scss';

const RulesPage = () => {
  return (
    <Layout className={styles.wrapper}>
      <RulesPageHeader />
      <RulesPageFilters />
      <RulesPageTableHeading />
      <RulesPageTable />
    </Layout>
  );
};

export default withRouter(RulesPage);
